import * as types from "./types";

/**
 * Reducer Acts (Phase 2.F).
 *
 * <p>Conserve la forme historique du state — {@code acts} et
 * {@code acts_price_insurer} restent des tableaux plats pour préserver les
 * consommateurs qui font {@code acts.map / .filter / .find}. La pagination
 * est exposée séparément dans {@code pagination} et {@code pagination_acts_price_insurer},
 * tolérante aux deux shapes (tableau plat hérité de l'alias rétro-compat,
 * map paginée si un appelant migre vers {@code getActs}).
 */

const INITIAL_STATE = {
  act: {
    actsTypeName: "",
    basePrice: 0,
    description: "",
    label: "",
  },
  acts: [],
  current_act: null,
  pagination: null,
  fetch_acts_status: false,
  create_acts_status: false,
  updating_acts: false,
  getting_act: false,
  error: null,
  delete_act_status: false,
  errors: [],
  acts_price_insurer: [],
  pagination_acts_price_insurer: null,
  getting_acts_price_insurer: false,
  creating_acts_price_insurer: false,
  updating_acts_price_insurer: false,
  deleting_acts_price_insurer: false,
};

/**
 * Tolère deux shapes : un tableau plat (cas alias rétro-compat) ou la map
 * paginée brute {@code {content, totalElements, ...}}.
 */
function splitPaginated(payload) {
  if (Array.isArray(payload)) {
    return { content: payload, pagination: null };
  }
  if (payload && typeof payload === "object" && Array.isArray(payload.content)) {
    const { content, ...meta } = payload;
    return { content, pagination: meta };
  }
  return { content: [], pagination: null };
}

export default function ActsReducers(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case types.CREATE_ACTS_REQUEST: {
      return {
        ...state,
        create_acts_status: true,
        error: null,
        errors: [],
      };
    }
    case types.CREATE_ACTS_SUCCESS:
      return {
        ...state,
        create_acts_status: false,
        error: null,
        errors: [],
      };
    case types.CREATE_ACTS_FAILURE: {
      return {
        ...state,
        create_acts_status: false,
        error: payload,
        errors: payload,
      };
    }

    case types.UPDATE_ACTS_REQUEST:
      return { ...state, updating_acts: true, errors: [] };
    case types.UPDATE_ACTS_SUCCESS:
      return { ...state, updating_acts: false, errors: [] };
    case types.UPDATE_ACTS_FAILURE:
      return { ...state, updating_acts: false, errors: payload };

    case types.FETCH_ACTS_REQUEST: {
      return {
        ...state,
        fetch_acts_status: true,
        error: null,
      };
    }
    case types.FETCH_ACTS_SUCCESS: {
      const { content, pagination } = splitPaginated(payload);
      return {
        ...state,
        acts: content,
        pagination,
        fetch_acts_status: false,
        error: null,
      };
    }
    case types.FETCH_ACTS_FAILURE: {
      return {
        ...state,
        fetch_acts_status: false,
        error: payload,
      };
    }

    case types.GET_ACTS_BY_ID_REQUEST:
      return { ...state, getting_act: true };
    case types.GET_ACTS_BY_ID_SUCCESS:
      return { ...state, getting_act: false, current_act: payload };
    case types.GET_ACTS_BY_ID_FAILURE:
      return { ...state, getting_act: false, error: payload };

    case types.DELETE_ACTS_REQUEST: {
      return {
        ...state,
        delete_act_status: true,
        error: null,
      };
    }
    case types.DELETE_ACTS_SUCCESS:
      return {
        ...state,
        delete_act_status: false,
        error: null,
      };
    case types.DELETE_ACTS_FAILURE: {
      return {
        ...state,
        delete_act_status: false,
        error: payload,
      };
    }

    case types.GET_ACTS_PRICE_INSURER_BY_INSURER_REQUEST: {
      return {
        ...state,
        getting_acts_price_insurer: true,
      };
    }
    case types.GET_ACTS_PRICE_INSURER_BY_INSURER_SUCCESS: {
      const { content, pagination } = splitPaginated(payload);
      return {
        ...state,
        getting_acts_price_insurer: false,
        acts_price_insurer: content,
        pagination_acts_price_insurer: pagination,
      };
    }
    case types.GET_ACTS_PRICE_INSURER_BY_INSURER_FAILURE: {
      return {
        ...state,
        getting_acts_price_insurer: false,
      };
    }
    case types.CREATE_ACTS_PRICE_INSURER_REQUEST: {
      return {
        ...state,
        creating_acts_price_insurer: true,
        errors: [],
      };
    }
    case types.CREATE_ACTS_PRICE_INSURER_SUCCESS:
      return {
        ...state,
        creating_acts_price_insurer: false,
        errors: [],
      };
    case types.CREATE_ACTS_PRICE_INSURER_FAILURE: {
      return {
        ...state,
        creating_acts_price_insurer: false,
        errors: payload,
      };
    }

    case types.UPDATE_ACTS_PRICE_INSURER_REQUEST: {
      return {
        ...state,
        updating_acts_price_insurer: true,
        errors: [],
      };
    }
    case types.UPDATE_ACTS_PRICE_INSURER_SUCCESS:
      return {
        ...state,
        updating_acts_price_insurer: false,
        errors: [],
      };
    case types.UPDATE_ACTS_PRICE_INSURER_FAILURE: {
      return {
        ...state,
        updating_acts_price_insurer: false,
        errors: payload,
      };
    }

    case types.DELETE_ACTS_PRICE_INSURER_REQUEST: {
      return {
        ...state,
        deleting_acts_price_insurer: true,
        errors: [],
      };
    }
    case types.DELETE_ACTS_PRICE_INSURER_SUCCESS:
      return {
        ...state,
        deleting_acts_price_insurer: false,
        errors: [],
      };
    case types.DELETE_ACTS_PRICE_INSURER_FAILURE: {
      return {
        ...state,
        deleting_acts_price_insurer: false,
        errors: payload,
      };
    }

    default:
      return state;
  }
}
